/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskAutomationCopyRuleType from '@jira/spa-apps__project-settings-service-desk-automation-copy-rule/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationCopyRule: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskAutomationCopyRuleType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-copy-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-copy-rule" */ '@jira/spa-apps__project-settings-service-desk-automation-copy-rule/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskAutomationCopyRule = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationCopyRule}
		pageId="project-settings-automation-copy-rule"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationCopyRule;
